import React from 'react';
import ashanImgSrc from './images/Ashan.png';
import globusImgSrc from './images/Globus.png';
// import lentaImgSrc from './images/Lenta.png';
import metroImgSrc from './images/Metro.png';
import { Container, Logo, LogoRow, LogoWrap, SoonBlock, SoonText, Text, TextContainer } from './styled';

export const MainLandingShops = () => {
  return (
    <Container>
      <TextContainer>
        <Text>
          Да! Теперь мы доставляем продукты и товары <br /> из магазинов
        </Text>
      </TextContainer>
      <LogoRow>
        <LogoWrap>
          <Logo src={ashanImgSrc} />
        </LogoWrap>
        <LogoWrap>
          <Logo src={globusImgSrc} />
        </LogoWrap>
        {/*<LogoWrap>*/}
        {/*  <Logo src={lentaImgSrc} />*/}
        {/*  <SoonBlock>*/}
        {/*    <SoonText>Скоро</SoonText>*/}
        {/*  </SoonBlock>*/}
        {/*</LogoWrap>*/}
        <LogoWrap>
          <Logo src={metroImgSrc} />
          <SoonBlock>
            <SoonText>Скоро</SoonText>
          </SoonBlock>
        </LogoWrap>
      </LogoRow>
    </Container>
  );
};
